module.exports = __webpack_public_path__ + "img/step4-05.e331547f.jpg";